import type { BrandId } from "./services/ai/brandRegistry";

/** Whether the user has turned Defaults off, and any brand they turned on by hand. */
export interface DefaultsChoice {
  /** The user turned Defaults off during this open. */
  optedOut: boolean;
  /**
   * Brand applied by a click while no organisation brand had resolved.
   * Ignored once a brand resolves, unless the user has opted out.
   */
  chosenBrandId: BrandId | null;
}

/** Defaults follows the resolved brand, and the user has not chosen otherwise. */
export const INITIAL_DEFAULTS_CHOICE: DefaultsChoice = {
  optedOut: false,
  chosenBrandId: null,
};

/** Record a click on the Defaults row. `null` turns Defaults off. */
export function defaultsChoiceFromUser(brandId: BrandId | null): DefaultsChoice {
  return {
    optedOut: brandId == null,
    chosenBrandId: brandId,
  };
}

/**
 * Brand id to send with a request, or `null` when Defaults is off.
 *
 * A resolved brand wins, including Finster Demo when that is the brand the
 * row is showing. A click applies a brand only while none has resolved.
 */
export function armedDefaultsBrandId(input: {
  /** Brand from `useActiveBrand`, or null when none has resolved. */
  resolvedBrandId: BrandId | null;
  /** The user turned Defaults off during this open. */
  optedOut: boolean;
  /** Brand the user turned on by hand before a brand resolved. */
  chosenBrandId: BrandId | null;
}): BrandId | null {
  if (input.optedOut) return null;
  if (input.resolvedBrandId) return input.resolvedBrandId;
  return input.chosenBrandId;
}
